import { useState } from "react";
import { Card, Input, Button, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

// Brak przeglądania listy (~2,36 mln aukcji) — wyszukiwanie konkretnego przetargu po
// `pretty_id`, a następnie edycja jego tytułu.
export const AuctionLookup = () => {
  const navigate = useNavigate();
  const [id, setId] = useState("");

  const open = () => {
    const value = id.trim();
    if (value) navigate(`/auctions/edit/${encodeURIComponent(value)}`);
  };

  return (
    <Card>
      <Title level={4}>Edycja tytułu przetargu</Title>
      <Paragraph type="secondary">
        Wpisz <code>pretty_id</code> przetargu, aby zmienić jego tytuł. Zapis utworzy nową
        rewizję i zsynchronizuje obie wyszukiwarki.
      </Paragraph>
      <Space.Compact style={{ width: "100%", maxWidth: 480 }}>
        <Input
          placeholder="np. 26-06-AB12CD"
          value={id}
          onChange={(e) => setId(e.target.value)}
          onPressEnter={open}
          allowClear
        />
        <Button type="primary" onClick={open} disabled={!id.trim()}>
          Otwórz
        </Button>
      </Space.Compact>
    </Card>
  );
};
